import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

const label = (d) => new Date(`${d}T12:00:00`).toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" });
const STATUS = { open: "Open", paid: "Paid, add details", confirmed: "Confirmed" };

const Row = ({ b, sponsors, onSaved }) => {
  const [sid, setSid] = useState(b.sponsor_id || "");
  const [msg, setMsg] = useState(b.message || "");
  const dirty = sid !== (b.sponsor_id || "") || msg !== (b.message || "");
  const save = async () => {
    try { await api.put(`/admin/roast/sponsorships/${b.date}`, { sponsor_id: sid || null, message: msg }); toast.success(`Saved for ${label(b.date)}`); onSaved(); } catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div className="border-t border-[#E7E7E7] py-3" data-testid={`roast-sponsor-row-${b.date}`}>
      <div className="flex items-center justify-between gap-2">
        <span className="font-mono-d text-sm">{label(b.date)}</span>
        <span className={`text-xs ${b.status === "paid" ? "text-[#E5332A] font-bold" : "text-[#575757]"}`}>{STATUS[b.status] || b.status}{b.payer_email ? ` · ${b.payer_email}` : ""}</span>
      </div>
      <div className="flex flex-col sm:flex-row gap-2 mt-2">
        <select data-testid={`roast-sponsor-select-${b.date}`} value={sid} onChange={(e) => setSid(e.target.value)} className="border border-input bg-white h-9 px-2 text-sm sm:w-48">
          <option value="">No sponsor (house ad)</option>
          {sponsors.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
        </select>
        <input data-testid={`roast-sponsor-message-${b.date}`} value={msg} onChange={(e) => setMsg(e.target.value)} maxLength={400} placeholder="Sponsor message (optional, else their description)" className="border border-input h-9 px-2 text-sm flex-1 min-w-0" />
        <button data-testid={`roast-sponsor-save-${b.date}`} disabled={!dirty} onClick={save} className="bg-[#0A0A0A] text-white px-4 h-9 text-sm disabled:opacity-40">Save</button>
      </div>
    </div>
  );
};

export const RoastSponsors = () => {
  const [rows, setRows] = useState(null);
  const [sponsors, setSponsors] = useState([]);
  const load = () => api.get("/admin/roast/sponsorships").then((r) => setRows(r.data));
  useEffect(() => { load(); api.get("/admin/sponsors").then((r) => setSponsors(r.data)); }, []);
  if (!rows) return null;
  return (
    <div className="bg-white border border-[#E7E7E7] p-6" data-testid="roast-sponsors-panel">
      <p className="font-display text-lg font-bold">Roast sponsors · £250 per issue</p>
      <p className="text-xs text-[#575757] mt-1">Sponsors who pay online appear here as "Paid". Pick their sponsor profile (add it in the Sponsors tab first) before 5am that Tuesday. For deals agreed offline, just pick the sponsor.</p>
      {rows.filter((b) => b.upcoming).map((b) => <Row key={`${b.date}-${b.sponsor_id}-${b.status}`} b={b} sponsors={sponsors} onSaved={load} />)}
    </div>
  );
};
